export default "__VITE_PUBLIC_ASSET__0bf4a8dd__"